/** A page headline with one or two of its words carried in the brand orange, so the top of every page
 *  has a point of colour instead of a single flat tone. Presentation only — the text is never altered.
 *
 *  The accented words are chosen from the headline's own shape: a leading "Day 4" / "Week 2" style
 *  label leads, otherwise the closing word (or the last two when that word is very short) does.
 */
const pick = (text) => {
  const trimmed = text.trim();
  const lead = trimmed.match(/^(\S+\s+\d+)(?=\s|$)/);
  if (lead) return { before: "", accent: lead[1], after: trimmed.slice(lead[1].length) };

  const words = trimmed.split(/\s+/);
  if (words.length === 1) return { before: "", accent: trimmed, after: "" };
  const last = words[words.length - 1];
  const accent = last.replace(/\W/g, "").length <= 3 && words.length > 2 ? words.slice(-2).join(" ") : last;
  const at = trimmed.lastIndexOf(accent);
  return { before: trimmed.slice(0, at), accent, after: trimmed.slice(at + accent.length) };
};

export const Accent = ({ children }) => {
  if (typeof children !== "string" || !children.trim()) return children ?? null;
  const { before, accent, after } = pick(children);
  return (
    <>
      {before}
      <span className="text-brand-orange">{accent}</span>
      {after}
    </>
  );
};
